// import external dependencies
import 'jquery';
import 'velocity-animate';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import lightbox from 'lightbox2';
import 'lightbox2/dist/css/lightbox.min.css';

lightbox.option({
  resizeDuration: 300,
  fadeDuration: 300,
  imageFadeDuration: 30,
  wrapAround: false,
  albumLabel : '%1 of %2',
  positionFromTop: 0,
  maxWidth: 1200,
});

// Import everything from autoload
import './autoload/jquery-plugins'; import './autoload/jquery-plugins/Accordion.js'; import './autoload/jquery-plugins/Anchor.js'; import './autoload/jquery-plugins/index.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import contact from './routes/contact';
import velocity from 'velocity-animate';

const userAgent = window.navigator.userAgent.toLowerCase();
if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
  require('custom-event-polyfill');
  require('picturefill');
  require('babel-polyfill');
  require('promise-polyfill');
  const objectFitImages = require('object-fit-images');
  objectFitImages();
  velocity.Promise = Promise;
}

/** Populate Router instance with DOM routes */
const routes = new Router({
  // 全ページ共通処理
  common,
  // ホーム
  home,
  // 問い合わせ系のページ
  contact,
});

// Load Events
document.addEventListener('DOMContentLoaded', () => routes.loadEvents())


// WEBPACK FOOTER //
// ./scripts/main.js